<template>
  <div class="about_address mt_7 pt_6">
    <title-box text="联系我们"></title-box>
    <div class="address content_box d_flex">
      <img src="../assets/about-us/address.png" alt="" class="" />
      <ul class="information d_flex flex_column justify_content_between">
        <li>
          <h6>公司地址</h6>
          <p>北京市海淀区上地十街1号院</p>
        </li>
        <li>
          <h6>联系电话</h6>
          <p>400-160-3672</p>
        </li>
        <li>
          <h6>邮箱地址</h6>
          <p>dlzhixiang@126.com</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import TitleBox from "@/components/title.vue";
export default {
  name: "Address",
  components: {
    TitleBox
  },
  data() {
    return {
      data: []
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.about_address {
  background: #faf9f7;
  padding: 70px;
  .address {
    margin-top: 55px;
    img {
      width: 600px;
      height: 380px;
    }
  }
  .information {
    margin-left: 100px;
    padding: 70px 0;
    li {
      margin-bottom: 35px;
      h6 {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #323232;
      }
      p {
        margin-top: 5px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
